import React from 'react';
import { BookOpen } from 'lucide-react';
import TeachersSection from '../../components/home/TeachersSection';
import { cardTheme } from '../../styles/cardTheme';

const PortalBrowse: React.FC = () => {
  return (
    <div className="pb-8">
      <div className="p-4 sm:p-6 lg:p-8 pb-0">
        <div className="mb-6 sm:mb-8">
          <div className={`inline-flex items-center gap-2 mb-4 ${cardTheme.badge}`}>
            <BookOpen className="w-4 h-4" />
            الحصص والكورسات
          </div>
          <h1 className={`text-2xl sm:text-3xl font-bold mb-2 ${cardTheme.title}`}>
            استكشف المحتوى التعليمي
          </h1>
          <p className={`max-w-2xl ${cardTheme.subtitle}`}>
            اختار مدرسك وشوف كورساته المتاحة.
          </p>
        </div>
      </div>

      <TeachersSection
        className="py-8 sm:py-12 bg-gradient-to-b from-green-50/40 via-white to-white"
        title="مدرسينا"
        subtitle="اختار المستر اللي بتحب تتعلم معاه"
        hint="اضغط على صورة المستر عشان تشوف كورساته"
        teacherPathPrefix="/student-portal/teacher"
      />
    </div>
  );
};

export default PortalBrowse;
